module.exports = __webpack_public_path__ + "img/selected2-min.f4c8329b.png";